import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import axios from 'axios'; 
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const EditUnitCategory = ({ show, onClose, unitcategoryId, onUpdated }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const [nameLengthError, setNameLengthError] = useState('');
    const [descLengthError, setDescLengthError] = useState('');  

    // Fetch the current department data when the modal is opened
    useEffect(() => {
        if (show && unitcategoryId) {
            axios.get(`${baseURL}/unitcategory/${unitcategoryId}`)
                .then(response => {
                    const { unitcategory_name, description } = response.data.data;
                    setName(unitcategory_name || '');
                    setDescription(description || ''); 
                })
                .catch(error => {
                    console.error("Error fetching department:", error);
                });
        }
    }, [show, unitcategoryId]);

    const handleNameChange = (e) => {
        let value = e.target.value || '';
        value = value.charAt(0).toUpperCase() + value.slice(1); // Capitalize first letter
        setName(value);

        if (value.length <= 300) {
            setNameLengthError('');
        }
    };

    const handleDescriptionChange = (e) => {
        let value = e.target.value || '';
        value = value.charAt(0).toUpperCase() + value.slice(1); // Capitalize first letter
        setDescription(value);

        if (value.length <= 500) {
            setDescLengthError('');
        }
    };

    const handleSubmit = () => {
        setErrors({});
        setNameLengthError('');
        setDescLengthError('');

        const safeName = name ?? '';
        const safeDescription = description ?? '';

        if (safeName.trim().length === 0) {
            setErrors(prev => ({
                ...prev,
                unitcategory_name: "This field is required"
            }));
            return;
        }

        if (safeName.length > 300) {
            setNameLengthError('Limit reached (max 300 characters)');
            return;
        }

        if (safeDescription.length > 500) {
            setDescLengthError('Limit reached (max 500 characters)');
            return;
        }

        axios.post(`${baseURL}/unitcategory/${unitcategoryId}`, {
            unitcategory_name: safeName,
            description: safeDescription,
        })
        .then(response => {
            onClose();
            if (onUpdated) onUpdated();
            toast.success("Unit Category Updated successfully!");
        })
        .catch(error => {
            if (error.response?.status === 400 && error.response.data.errors) {
                setErrors(error.response.data.errors);
            } else {
                console.error("Update failed:", error);
                toast.error("Updation Failed");
            }
        });
    };

    return (
        <>
            <Modal className="modal fade" show={show}  size="md">
                <div className="modal-content">
                    <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                        <h3 className="modal-title text-white">Update Unit Category</h3>
                        <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                            <span className='text-white'>×</span>
                        </Button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <label className="text-black font-w500 fs-7">Unit Category <span className="required">*</span></label>
                                <input type="text" 
                                className={`form-control ${errors.unitcategory_name ? 'is-invalid' : ''}`}
                                
                                value={name}
                                onChange={handleNameChange}
                                placeholder="Enter Unit Category"  />
                                {errors.department_name && (
                                <div className="invalid-feedback">{errors.unitcategory_name}</div>
                            )}
                            {nameLengthError && (
                                <span className="text-danger">{nameLengthError}</span>
                            )}
                            </div>
                            <div className="col-lg-12 mb-4">
                                <label className="text-black font-w500 fs-7">Description</label>
                               <textarea
                                rows={4}
                                className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                                placeholder="Description"
                                value={description}
                                onChange={handleDescriptionChange}
                            />
                            {descLengthError && (
                                <span className="text-danger">{descLengthError}</span>
                            )}
                            </div>
                        </div>
                        {/* <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
                            <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                            <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Update Unit Category</Link>
                        </div> */}
                         {/* <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
                            <Button variant="secondary" size="sm" onClick={onClose}>Cancel</Button>
                            <Button variant="primary" size="sm" onClick={handleSubmit}>Update Unit Category</Button>
                        </div> */}
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                            <button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Update Unit Category
                            <i className="fas fa-angle-double-right ms-2"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default EditUnitCategory; 
